import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["sign", "absolute", "signed", "summary"]

  declare readonly signTargets: HTMLInputElement[]
  declare readonly absoluteTarget: HTMLInputElement
  declare readonly signedTarget: HTMLInputElement
  declare readonly hasSummaryTarget: boolean
  declare readonly summaryTarget: HTMLElement

  private sign = "ground"

  connect() {
    const checked = this.signTargets.find((radio) => radio.checked)
    this.sign = checked?.dataset.floorInputSignParam || "ground"
    this.convert()
  }

  chooseSign(event: Event & { params: { sign: string } }) {
    this.sign = event.params.sign
    this.convert()
  }

  convert() {
    const absolute = Math.abs(Number(this.absoluteTarget.value))
    this.signedTarget.value = !Number.isInteger(absolute) || absolute === 0
      ? ""
      : String(this.sign === "basement" ? -absolute : absolute)
    this.render()
  }

  render() {
    if (!this.hasSummaryTarget) return

    this.summaryTarget.textContent = this.signedTarget.value
      ? `${this.sign === "basement" ? "地下" : "地上"}${this.absoluteTarget.value}階`
      : "—"
  }
}
